import { PartnerMark } from "@/components/PartnerMark";

export const PartnerMarquee = ({ partners }) => {
  if (!partners.length) return null;
  return (
    <div className="relative overflow-hidden" data-testid="partner-marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-ivory to-transparent" aria-hidden="true" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-ivory to-transparent" aria-hidden="true" />
      <div className="marquee-track flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center gap-16 pr-16" aria-hidden={copy === 1}>
            {partners.map((p, i) => (
              <span key={`${p.id}-${i}`} className="flex items-center gap-16">
                <PartnerMark
                  name={p.name}
                  logo={p.logo || p.image}
                  imgClassName="h-9 w-auto max-w-[10rem] object-contain opacity-70 grayscale transition-all duration-500 hover:opacity-100 hover:grayscale-0"
                  textClassName="whitespace-nowrap font-serif text-2xl italic text-slate/60 transition-colors duration-500 hover:text-concordia"
                />
                <span className="h-1.5 w-1.5 rotate-45 bg-brass/50" aria-hidden="true" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
